<template>
  <transition name="slide">
    <div
      v-if="sensor !== null"
      class="sensor-details absolute top-0 bottom-0 shadow z-10 w-full sm:w-80 lg:w-96"
    >
      <div class="h-full flex flex-col sm:w-80 lg:w-96">
        <div class="w-full overflow-hidden">
          <Header class="opacity-0 sm:opacity-100 pointer-events-none sm:pointer-events-auto" :inverted="true"/>
        </div>
        <div class="flex-1 bg-white overflow-auto border-t">
          <div class="flex items-center pt-1 sticky top-0 z-10 bg-white">
            <a class="hidden sm:inline-block flex-1 px-4 hover:underline cursor-pointer" v-on:click="localize()">
              <Icon :icon="['fas', 'fa-map-marker-alt', 'text-gray-500']"/>
              <span class="ml-2">{{$t('marker.locate')}}</span>
            </a>
            <a class="flex-1 sm:hidden px-4 hover:underline cursor-pointer" v-on:click="clearAndLocalize()">
              <Icon :icon="['fas', 'fa-map-marker-alt', 'text-gray-500']"/>
              <span class="ml-2">{{$t('marker.show')}}</span>
            </a>
            <md-button class="md-icon-button md-primary" v-on:click="clearSensor()">
              <Icon :icon="['fas', 'fa-times', 'text-base']"/>
            </md-button>
          </div>
          
          <SensorData/>
          <HistoryChart :sensorId="sensorId"/>
          <CodeModal :id="sensorId"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '@/components/atoms/Icon';
import Header from '@/components/molecules/Header';
import HistoryChart from '@/components/molecules/HistoryChart';
import SensorData from '@/components/molecules/SensorData';
import CodeModal from '@/components/molecules/CodeModal'

export default {
  name: 'DetailsPanel',
  components: {
    Icon,
    Header,
    SensorData,
    HistoryChart,
    CodeModal,
  },

  computed: {
    ...mapGetters([
      'sensor',
    ]),

    sensorId() {
      return Number(this.sensor.id);
    }
  },

  methods: {
    clearSensor() {
      this.$router.push({ name: 'map' });
    },

    clearAndLocalize() {
      this.localize();
      this.clearSensor();
    },

    localize() {
      this.$emit('localizeSensor', this.sensor.geolocation);
    }
  },
};
</script>

<style lang="scss" scoped>
.slide-enter-active, .slide-leave-active {
  transition: width .3s ease-in-out;
  min-width: 0;
}

.slide-enter, .slide-leave-to {
  width: 0;
}

.opacity-0 {
  transition: opacity .3s;
}

.flex a {
  @apply .text-gray-800 .text-sm;
}

.md-icon-button {
  @apply .mx-1;
}
</style>
